import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import { ListaDepartamentos, ListaDistritos, ListaProvincias } from "../shared/Ubigeo";
import Paginador from "./components/Paginador";
import { ValidarNumLtr } from "../shared/Regex";

export default function Clientes(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[listaClientes, setListaClientes] = useState(<></>);

    // ESTADOS DE FILTRO
    const[filtroCliente, setFiltroCliente] = useState("");
    const[filtroDpto, setFiltroDpto] = useState("00");
    const[filtroProv, setFiltroProv] = useState("00");
    const[filtroDist, setFiltroDist] = useState("00");
    const[filtroUbigeo, setFiltroUbigeo] = useState("000000");
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerListaClientes(filtroCliente, filtroUbigeo, 1);
    },[]);

    // Actualizar ubigeo al cambiar de dpto, prov o dist
    useEffect(()=>{
        HandlerFiltroUbigeo(`${filtroDpto}${filtroProv}${filtroDist}`)
    },[filtroDpto, filtroProv, filtroDist]);

    useEffect(()=>{
        HandlerFiltroProv("00");
    },[filtroDpto]);

    useEffect(()=>{
        HandlerFiltroDist("00");
    },[filtroProv])

    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const HandlerListaClientes = (lista) => setListaClientes(lista);
    // ESTADOS DE FILTRO
    const HandlerFiltroCliente = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setFiltroCliente(valor.toUpperCase());
        }
    }
    const HandlerFiltroDpto = (valor) => setFiltroDpto(valor);
    const HandlerFiltroProv = (valor) => setFiltroProv(valor);
    const HandlerFiltroDist = (valor) => setFiltroDist(valor);
    const HandlerFiltroUbigeo = (valor) => setFiltroUbigeo(valor);
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerListaClientes = async(cliente, ubigeo, pagina) => {
        const paramCliente = cliente == "" ? "-" : cliente;
        try{
            const response = await axios.get(URL_LISTAR_CLIENTES,{
                headers:HEADERS_API,
                params:{
                    fCliente: paramCliente,
                    fUbigeo: ubigeo,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });            
            HandlerListaClientes(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error);
        }
    }
    const QuitarFiltros = () => {
        HandlerFiltroCliente("");
        HandlerFiltroDpto("00");
        ObtenerListaClientes("", "000000", 1);
    }
    // FUNCIONES COMPLEMENTARIAS

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaClientes(filtroCliente, filtroUbigeo, pagina);
    }
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>CLIENTES / PROVEEDORES</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nuevo-cliente"}>
                    <button className="btn btn-primary">Nuevo Cliente / Proveedor</button>
                </Link>
            </div>
            {/* FILTROS */}
            <div className="col-12 col-md-4 p-1">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroCliente(e.target.value)} value={filtroCliente} maxLength={50} type="text" className="form-control" placeholder="Buscar" id="filtro-cliente" autoComplete="off"/>
                    <label htmlFor="filtro-cliente">Buscar</label>
                </div>
            </div>
            <div className="col-12 col-md-2 p-1">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroDpto(e.target.value)} value={filtroDpto} id="filtro-dpto" className="form-select" placeholder="Departamento">
                        <option value="00">Todos</option>
                        <ListaDepartamentos/>
                    </select>
                    <label htmlFor="filtro-dpto">Departamento</label>
                </div>
            </div>
            <div className="col-12 col-md-2 p-1">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroProv(e.target.value)} value={filtroProv} id="filtro-prov" className="form-select" placeholder="Provincia">
                        <option value="00">Todos</option>
                        <ListaProvincias departamento={filtroDpto}/>
                    </select>
                    <label htmlFor="filtro-prov">Provincia</label>
                </div>
            </div>
            <div className="col-12 col-md-2 p-1">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroDist(e.target.value)} value={filtroDist} id="filtro-dist" className="form-select" placeholder="Distrito">
                        <option value="00">Todos</option>
                        <ListaDistritos provincia={filtroProv} departamento={filtroDpto}/>
                    </select>
                    <label htmlFor="filtro-dist">Distrito</label>
                </div>
            </div>
            <div className="col-12 col-md-2">
                <button onClick={e=>ObtenerListaClientes(filtroCliente, filtroUbigeo, 1)} className="btn btn-primary my-1 w-100">Filtrar</button>
                <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
            </div>
            {/* TABLA */}
            <div className="contenedor-tabla py-4">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>N° Documento</th>
                            <th>Razón Social</th>
                            <th>Es Proveedor</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaClientes.length > 0 ? listaClientes.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.nroDoc}</td>
                                    <td>{item.razSoc}</td>
                                    {item.esProv == 1 ? (<td className="text-success fw-bold">SI</td>) : (<td className="text-secondary fw-bold">NO</td>)}
                                    <td>
                                        <Link to={`/detalle-cliente/${item.nroDoc}`} className="btn btn-primary">
                                        Detalles
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center">
                {paginador}
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_LISTAR_CLIENTES = process.env.REACT_APP_URL_LISTAR_CLIENTES;
//#endregion